import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TaskApi, TaskDTO, TaskFilterDTO,ReportTaskDTO } from './TaskApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faArrowLeft,
  faPlus,faCircleInfo,
  faChevronDown,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { TaskStatusOptions } from '../../../constants/taskConstants';
import { title } from 'process';
import {
    faEdit, faTrash, faFileUpload,faEye
} from '@fortawesome/free-solid-svg-icons';
import { EntityType, UploadContexts } from '../../../constants/globalConstants'; 
import ProjectActions from '../ProjectActions';
import {NestedTaskDTO} from './TaskApi'
import ProjectTaskActions from './ProjectTaskActions';
import TaskStatusHelpModal from './TaskStatusHelpModal';


const user = JSON.parse(localStorage.getItem('user') || '{}');
const userId = user.id || '';
const userName = user.namename || '';
const tenantId = user.tenantId || '';
const tenantName = user.tenantName || '';

const defaultFilters: TaskFilterDTO = {
  status: '',
  taskType: '',
  priority: '',
  projectName: '',
  projectId: '',
  title: '',
  assignedTo: '',
  givenStartDate: '',
  givenEndDate: '',
};


export const TaskList: React.FC = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState<TaskFilterDTO>(defaultFilters);
  const [tasks, setTasks] = useState<NestedTaskDTO[]>([]);
  const [expandedTaskIds, setExpandedTaskIds] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  //Tenant and user details
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const tenantId = user?.tenantId || '';
  const tenantName = user?.tenantName || '';
  const userId = user?.id || '';
  const [showHelpModal, setShowHelpModal] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateTask= (task: TaskDTO, levelNumber:string) => {
    
    navigate('/project-tasks/create', {
      state: {
        
        tenantId: tenantId,
        tenantName: tenantName,
        projectName: task.projectName,
        parentId: task.id ,
        title: task.title,
        projectId: task.projectId,
        contractId: task.contractId,
        description: task.description,
        levelNumber: levelNumber,
      }
    });
  };

  const handleViewTask= (task: TaskDTO, levelNumber:string) => {
    
    navigate('/project-tasks/${task.id}', {
      state: {
        
        tenantId: tenantId,
        tenantName: tenantName,
        projectName: task.projectName,
        parentId: task.id ,
        title: task.title,
        projectId: task.projectId,
        contractId: task.contractId,
        description: task.description,
        levelNumber: levelNumber,
      }
    });
  };
  const handleSearch = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await TaskApi.filter(filters);
      setTasks(res.data);
    } catch (err) {
      setError('Failed to fetch task data.');
      setTasks([]);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilters(defaultFilters);
    handleSearch();
  };

  const handleDelete = async (id: string) => {
    if (confirm('Are you sure you want to delete this task?')) {
      await TaskApi.delete(id);
      handleSearch();
    }
  };

  const toggleExpand = (taskId: string) => {
    setExpandedTaskIds((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  const getRowBackgroundColor = (depth: number): string => {
    const colorMap: Record<number, string> = {
      0: 'bg-white',
      1: 'bg-blue-50',
      2: 'bg-green-50',
      3: 'bg-yellow-50',
      4: 'bg-purple-50',
    };
    return colorMap[depth] || 'bg-gray-100';
  };

  const renderNestedTasks = (
    taskList: NestedTaskDTO[],
    prefix = '',
    depth = 0
  ): JSX.Element[] => {
    return taskList.flatMap((task, index) => {
      const levelNumber = prefix ? `${prefix}.${index + 1}` : `${index + 1}`;
      const isExpanded = expandedTaskIds[task.id];
      const hasChildren = task.children && task.children.length > 0;
      const rowBgColor = getRowBackgroundColor(depth);
      const indent = levelNumber.split('.').length * 16;
  
      const maxLevelReached = levelNumber.split('.').length >= 4;
  
      const row = (
        <tr key={task.id} className={`hover:bg-gray-100 ${rowBgColor}`}>
          <td className="p-2 border text-center">
            {hasChildren && (
              <button onClick={() => toggleExpand(task.id)}>
                <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight} />
              </button>
            )}
          </td>
          

          <td className="p-2 border text-center">{levelNumber}</td>
          <ProjectTaskActions
            task={task}
            levelNumber={levelNumber}
            maxLevelReached={maxLevelReached}
            handleDelete={handleDelete}
            handleCreateTask={handleCreateTask}
          />
           <td className="p-2 border" style={{ paddingLeft: `${indent}px` }}>
            {task.title}
          </td>
          <td className="p-2 border">{task.projectName}</td>
          <td className="p-2 border">{task.status}</td>
          <td className="p-2 border">{task.priority}</td>
          <td className="p-2 border">{task.progress}</td>
          <td className="p-2 border">{task.description}</td>
          <td className="p-2 border">{task.taskType}</td>
          <td className="p-2 border">{task.units}</td>
          <td className="p-2 border">{task.estimatedQuantity}</td>
          <td className="p-2 border">{task.estimatedRate}</td>
        
          <td className="p-2 border">{task.estimatedTotalAmountWithoutTax}</td>
          <td className="p-2 border">{task.taxPercentage}</td>
          <td className="p-2 border">{task.estimatedTotalTaxAmount}</td>
          <td className="p-2 border">{task.estimatedTotalAmountWithTax}</td>

          <td className="p-2 border">{task.actualQuantity}</td>
          <td className="p-2 border">{task.actualRate}</td>
          <td className="p-2 border">{task.actualTotalAmountWithoutTax}</td>
          <td className="p-2 border">{task.actualTotalTaxAmount}</td>
          <td className="p-2 border">{task.actualTotalAmountWithTax}</td>
      
         
          
          
         
          
          {/* <td className="p-2 border">{task.assignedTo}</td> */}
          <td className="p-2 border">{task.givenStartDate}</td>
          <td className="p-2 border">{task.givenEndDate}</td>
          <td className="p-2 border">{task.actualStartDate}</td>
          <td className="p-2 border">{task.actualEndDate}</td>
          <td className="p-2 border">{task.comment}</td>
          <td className="p-2 border">{task.rejectionReason}</td>

                 
        </tr>
      );
  
      const childrenRows =
        hasChildren && isExpanded
          ? renderNestedTasks(task.children!, levelNumber, depth + 1)
          : [];
  
      return [row, ...childrenRows];
    });
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div className="p-6 bg-white rounded shadow">
      <button
        onClick={() => navigate(-1)}
        className="mb-4 inline-flex items-center text-sm text-blue-600 hover:underline"
      >
        <FontAwesomeIcon icon={faArrowLeft} className="mr-2" /> Back
      </button>

      <div className="mb-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Task Search</h1>
        {/* <button
          onClick={() => navigate('/project-tasks/create')}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 flex items-center text-sm"
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Create Task
        </button> */}
         {/* Top-right info button */}
      <div className="flex justify-end p-2">
        <button
          className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
          onClick={() => setShowHelpModal(true)}
        >
          <FontAwesomeIcon icon={faCircleInfo} />
          Help
        </button>
      </div>

      {/* Existing Task List Component UI here */}

      {/* Help Modal */}
      <TaskStatusHelpModal isOpen={showHelpModal} onClose={() => setShowHelpModal(false)} />
      </div>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-gray-50 p-4 rounded mb-4 border">
        {Object.keys(defaultFilters).map((key) => {
          if (key === 'status') {
            return (
              <div key={key}>
                <label className="text-sm font-medium block mb-1">Status</label>
                <select
                  name="status"
                  value={filters.status || ''}
                  onChange={handleInputChange}
                  className="border px-3 py-2 rounded w-full"
                >
                  <option value="">All Statuses</option>
                  {TaskStatusOptions.map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
              </div>
            );
          }

          return (
            <div key={key}>
              <label className="text-sm font-medium block mb-1">
                {key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase())}
              </label>
              <input
                type="text"
                name={key}
                value={(filters as any)[key] || ''}
                onChange={handleInputChange}
                className="border px-3 py-2 rounded w-full"
              />
            </div>
          );
        })}

        <div className="md:col-span-4 flex gap-2 mt-2">
          <button
            onClick={handleSearch}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center"
          >
            <FontAwesomeIcon icon={faSearch} className="mr-2" /> Apply Filters
          </button>
          <button
            onClick={handleReset}
            className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
          >
            Reset
          </button>
        </div>
      </div>

      {/* Task Table */}
      {loading ? (
        <div className="text-center">Loading...</div>
      ) : error ? (
        <div className="text-red-500">{error}</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-200 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border w-8 text-center">▶</th>
                <th className="p-2 border text-center">Level</th>
                <th className="p-2 border">Actions</th>
                <th className="p-2 border">Title</th>
                <th className="p-2 border">Project</th>
                <th className="p-2 border">Status</th>
                <th className="p-2 border">Priority</th>
                <th className="p-2 border">Progress (%)</th>
                <th className="p-2 border">Description</th>
                <th className="p-2 border">Task Type</th>
                <th className="p-2 border">Units</th>
                <th className="p-2 border">Estimated Quantity</th>
                <th className="p-2 border">Estimated Rate</th>
                <th className="p-2 border">Estimated Total Amount Without Tax </th>
                <th className="p-2 border">Tax (%)</th>
                <th className="p-2 border">Estimated Total Tax Amount</th>
                <th className="p-2 border">Estimated Total Amount With Tax</th>
                <th className="p-2 border">Actual Quantity</th>
                <th className="p-2 border">Actual Rate</th>
                <th className="p-2 border">Actual Total Amount WithoutT ax </th>
                <th className="p-2 border">Actual Total Tax Amount</th>
                <th className="p-2 border">Actual Total Amount With Tax </th>
               <th className="p-2 border">Given Start Date</th>
                <th className="p-2 border">Given End Date</th>
                <th className="p-2 border">Actual Start Date</th>
                <th className="p-2 border">Actual End Date</th>
                <th className="p-2 border">Comments</th>
                <th className="p-2 border">Rejection Reason</th>
              </tr>
            </thead>
            <tbody>{renderNestedTasks(tasks)}</tbody>
          </table>
        </div>
      )}
    </div>
  );
};